import React from "react";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import { TextField } from "@mui/material";
import { useFormContext } from "react-hook-form";

interface PropTypes {
  formValue: string;
  limit: number;
  label: string;
}

//Input de tipo textArea con manejador de errores,
//formValue es el nombre del campo del formulario
//limit el número máximo de caracteres que se pueden escribir
const InputTextAreaComponent = ({ formValue, limit, label }: PropTypes) => {
  const { register, watch, formState } = useFormContext();
  const watcher = watch();
  const { errors, touchedFields, dirtyFields } = formState;

  const errorText = errors[formValue]?.message;

  return (
    <div className="w-full flex flex-col p-2">
      <div className="flex">
        <ChatBubbleIcon sx={{ marginRight: "5px" }} />

        <TextField
          id="outlined-textarea"
          label={label}
          placeholder="Máximo 500 caracteres"
          minRows={4}
          className="w-full"
          {...register(formValue)}
        />
      </div>

      {/* Administración de errores y contador de caracteres dinámico */}
      <div className="flex">
        {watcher[formValue]?.length > limit && !errors[formValue] && (
          <p className="error-message">
            Has excedido el máximo de {limit} caracteres
          </p>
        )}
        {touchedFields &&
          touchedFields[formValue] &&
          !dirtyFields[formValue] &&
          !errors[formValue] && (
            <p className="error-message">Este campo es requerido</p>
          )}
        {errors && <p className="error-message">{errorText?.toString()}</p>}

        <p className="p-2 w-max ml-auto mb-0 text-sm">
          {watcher[formValue]?.length}/{limit}
        </p>
      </div>
    </div>
  );
};

export { InputTextAreaComponent };
